
import * as utils from "../utils/basic";

export const SET_FILE_ID = "SET_FILE_ID";
export const SET_FILES = "SET_FILES";
export const SET_CLEAR_FILES = "SET_CLEAR_FILES";
export const FILE_UPLOAD_COMPLETED = "FILE_UPLOAD_COMPLETED";
export const FILES_S3 = "FILES_S3";
export const FILES_S3_SIGNED_UPLOADED = "FILES_S3_SIGNED_UPLOADED";

export function setFileId() {
    return dispatch => {
        dispatch({ type: SET_FILE_ID, fileId: utils.guid() });
    };
}

export function setFiles(files) {
    return dispatch => {
        dispatch({ type: SET_FILES, files });
    };
}

export function clearUploadFiles() {
    return dispatch => {
        dispatch({ type: SET_CLEAR_FILES });
    }
}

export function fileUploadCompletedStatus(fileId, isUploadComplete) {
    return dispatch => {
        dispatch({ type: FILE_UPLOAD_COMPLETED, fileId, payload: isUploadComplete });
    };
}

export function filesS3(fileId, files) {
    return dispatch => {
        dispatch({
            type: FILES_S3, fileId,
            payload: files
        });
    }
}

export function filesS3SignedUploaded(fileId, files, thisFileIndex, thisPartIndex, progressEvent) {
    return dispatch => {
        dispatch({
            type: FILES_S3_SIGNED_UPLOADED, fileId, thisFileIndex, thisPartIndex, progressEvent,
            payload: files
        });
    }
}
